<template>
  <div id="questionContent" v-no-copy-paste @keydown="blockPrintScreen">
    <ModalQuitter
        v-if="isModalVisible"
        @close="closeModal"
    />
    <ModalFinish
        v-if="isModalFinishVisible"
        @close="closeModalFinish"
        @finish="finish"
    />
    <ModalRappel
        v-if="isModalRappelVisible"
        :message=messageRappel
        @close="closeModalRappel"
    />

    <p class="print-warning">Veuillez ne pas imprimer cette page.</p>

    <div class="questionnaire-body hide-on-print"/>
    <div v-if='isEnd() && !autoSubmit' class="questionnaire-question-header">
      <div class="questionnaire-question-header-title">{{ header }}</div>
    </div>

    <div v-if='isEnd() && !autoSubmit && type && type !== "video"' class="questionnaire-question-bar hide-on-print">
      <div class="questionnaire-question-bar-info">
        <div class="questionnaire-question-bar-info-left">
          <img alt="" src="@/assets/img/time.png"/>
          <span id="countDown"></span>
        </div>
        <span id="initialTimer"></span>
        <span id="answer_dev"></span>
        <div class="questionnaire-question-bar-info-right">Question {{ indexQuestion }}/{{ maxQuestion }}</div>
      </div>

      <div class="questionnaire-question-bar-pause" @click="showModal">
        <img src="@/assets/img/navbar/home.png" alt="">
      </div>
    </div>

    <div class="hide-on-print">
      <p id="copy-paste-msg" class="d-none text-danger copy-message">L'action "copier-coller" n'est pas autorisée</p>
      <QuestionVideo v-if="type==='video'"
                     ref="markdowndetails"
                     :question=question
                     :userId="idUserTest"
                     @video-completed="onVideoCompleted"
                     @back-later="router().push({name: 'mes-tests'})"
      />

      <QuestionModifyUnderscore v-if="type==='modify_underscore'"
                                ref="markdowndetails"
                                :audio=audio
                                :error=error
                                :image=image
                                :question=question
                                :regex=regex
                                :statement=statement
                                @update:error="error = $event"
      />

      <QuestionChooseWordToChange v-if="type==='choose_word_to_change'"
                                  ref="markdowndetails"
                                  :audio=audio
                                  :error=error
                                  :question=question
                                  :regex=regex
                                  :statement=statement
                                  @update:error="error = $event"
      />

      <QuestionSelectGoodResponse v-if="type==='select_good_response'"
                                  ref="markdowndetails"
                                  :image=image
                                  :question=question
                                  :statement=statement
      />

      <QuestionMultipleCheckbox v-if="type==='multiple_checkbox'"
                                ref="markdowndetails"
                                :question=question
                                :statement=statement
      />


      <QuestionMultipleCheckboxWithText v-if="type==='multiple_checkbox_with_text'"
                                        ref="markdowndetails"
                                        :idQuestion=idQuestion
                                        :previousStatement=previousStatement
                                        :propositions=propositions
                                        :question=question
                                        :statement=statement
                                        :title=title
      />

      <QuestionMultipleCheckboxWithAudio v-if="type==='multiple_checkbox_with_audio'"
                                         ref="markdowndetails"
                                         :audio=audio
                                         :previousStatement=previousStatement
                                         :propositions=propositions
                                         :question=question
                                         :statement=statement
                                         :title=title
      />

      <QuestionArgumentation v-if="type==='argumentaire'"
                             ref="markdowndetails"
                             :question=question
                             :response=response
      />

      <QuestionWriteNumberResponse v-if="type==='write_number_response'"
                                   ref="markdowndetails"
                                   :error=error
                                   :question=question
                                   :regex=regex
                                   :response=response
                                   :statement=statement
                                   @update:error="error = $event"
      />

      <QuestionFraction v-if="type==='fraction'"
                        ref="markdowndetails"
                        :error=error
                        :question=question
                        :regex=regex
                        :response=response
                        :statement=statement
                        @update:error="error = $event"
      />

      <QuestionWriteTimeResponse v-if="type==='write_time_response'"
                                 ref="markdowndetails"
                                 :error=error
                                 :question=question
                                 :regex=regex
                                 :response=response
                                 :statement=statement
                                 @update:error="error = $event"
      />

      <QuestionAbstrait v-if="type==='abstrait'"
                        ref="markdowndetails"
                        :image=image
                        :propositions=propositions
                        :question=question
                        :statement=statement
      />

      <QuestionFinish v-if="type==='finish'" :auto-submit="autoSubmit" :id-user-test="idUserTest"/>

      <QuestionWriteTextResponse v-if="type==='write_text_response'"
                                 ref="markdowndetails"
                                 :error=error
                                 :question=question
                                 :regex=regex
                                 :response=response
                                 :statement=statement
                                 @update:error="error = $event"
      />
    </div>

    <div v-if='isEnd() && type !== "video"' class="questionnaire-question-footnav hide-on-print">
      <div v-if='!isFirstQuestion("previous") && pageIsLoaded' class="questionnaire-question-footnav-previous" @click.prevent="previous">
        <img src="@/assets/img/arrow-previous.png" alt="">
      </div>
      <div v-if='isFirstQuestion("next") && pageIsLoaded' class="questionnaire-question-footnav-after" @click.prevent="next">
        <img src="@/assets/img/arrow-after.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

import QuestionVideo from '@/components/Questionnaire/Question/Video.vue'
import QuestionModifyUnderscore from '@/components/Questionnaire/Question/ModifyUnderscore.vue'
import QuestionChooseWordToChange from '@/components/Questionnaire/Question/ChooseWordToChange.vue'
import QuestionSelectGoodResponse from '@/components/Questionnaire/Question/SelectGoodResponse.vue'
import QuestionMultipleCheckbox from '@/components/Questionnaire/Question/MultipleCheckbox.vue'
import QuestionMultipleCheckboxWithText from '@/components/Questionnaire/Question/MultipleCheckboxWithText.vue'
import QuestionMultipleCheckboxWithAudio from '@/components/Questionnaire/Question/MultipleCheckboxWithAudio.vue'
import QuestionArgumentation from '@/components/Questionnaire/Question/Argumentation.vue'
import QuestionWriteNumberResponse from '@/components/Questionnaire/Question/WriteNumberResponse.vue'
import QuestionFraction from '@/components/Questionnaire/Question/Fraction.vue'
import QuestionWriteTimeResponse from '@/components/Questionnaire/Question/WriteTimeResponse.vue'
import QuestionWriteTextResponse from '@/components/Questionnaire/Question/WriteTextResponse.vue'

import QuestionAbstrait from '@/components/Questionnaire/Question/Abstrait.vue'

import QuestionFinish from '@/components/Questionnaire/Finish.vue'
import UserService from "@/services/user.service";

import ModalRappel from '@/components/Modal/Questionnaire/Rappel.vue'
import ModalQuitter from '@/components/Modal/Questionnaire/Quitter.vue';
import ModalFinish from '@/components/Modal/Questionnaire/Finish.vue';
import router from "@/router/router";
import TestApi from "@/api/TestApi";
import RouteEnum from "@/router/RouteEnum";

export default {
  name: "QuestionForm",
  components: {
    QuestionVideo,
    QuestionModifyUnderscore,
    QuestionChooseWordToChange,
    QuestionSelectGoodResponse,
    QuestionMultipleCheckbox,
    QuestionMultipleCheckboxWithText,
    QuestionMultipleCheckboxWithAudio,
    QuestionArgumentation,
    QuestionWriteNumberResponse,
    QuestionFraction,
    QuestionWriteTimeResponse,
    QuestionWriteTextResponse,
    QuestionAbstrait,
    QuestionFinish,
    ModalQuitter,
    ModalFinish,
    ModalRappel,
  },
  directives: {
    'no-copy-paste': {
      mounted(el) {
        const msgCopyPaste = document.getElementById('copy-paste-msg');
        el.addEventListener('copy', (e) => {
          e.preventDefault();
          msgCopyPaste.classList.remove('d-none');
        });
        el.addEventListener('paste', (e) => {
          e.preventDefault();
          msgCopyPaste.classList.remove('d-none');
        });
        el.addEventListener('cut', (e) => {
          e.preventDefault();
          msgCopyPaste.classList.remove('d-none');
        });
        el.addEventListener('mouseup', () => {
          msgCopyPaste.classList.add('d-none');
        });
        el.style.userSelect = 'none';
      },
    },
  },
  provide() {
    return {
      parentContext: this
    }
  },
  data() {
    let ifProduction = true;

    let tld = process.env.VUE_APP_API_URL.split(".").slice(-1)[0];

    if (["dev", "test", "cloud"].includes(tld)) {
      ifProduction = false;
    }

    let localLimitTestText = localStorage.getItem('textLimitTest');
    let messageRappel = "";

    return {
      domain: this.$route.params.type,
      domainId: 0,
      indexQuestion: 1,
      question: null,
      type: null,
      autoSubmit: false,
      maxQuestion: 100,
      answer: null,
      endedAt: null,
      listen: 0,
      statement: '',
      previousStatement: null,
      audio: null,
      idUserTest: 0,
      arrayQuestions: null,
      arrayResponses: null,
      intCountDown: null,
      propositions: null,
      header: 'Test',
      isModalVisible: false,
      isModalFinishVisible: false,
      isModalRappelVisible: false,
      ifFirstPage: true,
      countDown: null,
      timeElapsed: 0,
      image: null,
      idQuestion: 0,
      pageIsLoaded: false,
      regex: '',
      response: '',
      error: false,
      dateEnd: new Date(),
      limitTestText: localLimitTestText,
      messageRappel: messageRappel,
      ifProduction: ifProduction
    }
  },
  methods: {
    router() {
      return router
    },
    isEnd: function () {
      return this.maxQuestion >= this.indexQuestion
    },
    isFirstQuestion: function (button) {
      if (this.type === 'argumentaire') {
        return this.ifFirstPage;
      }
      if (button === "next") return true
      return this.indexQuestion === 1
    },
    next: function () {
      if (!this.error) {
        if (!this.pageIsLoaded) return
        if (this.type === 'video') {
          // Pour le type vidéo, pas de navigation next/previous
          return
        } else if (this.type === 'multiple_checkbox_with_text' && this.$refs.markdowndetails.ifFirstPage) {
          this.$refs.markdowndetails.ifFirstPage = false;
          this.ifFirstPage = false;
        } else if (this.type === 'argumentaire') {
          this.ifFirstPage = false
          this.$refs.markdowndetails.ifFirstPage = false;
        } else {

          this.pageIsLoaded = false
          this.saveResponse().then(
              (response) => {
                if (undefined === response.error) {
                  this.indexQuestion = this.indexQuestion + 1
                  this.previousStatement = this.statement
                  if (this.indexQuestion > this.maxQuestion) {
                    this.type = "finish"
                  } else {
                    this.changeQuestion()
                  }
                  this.pageIsLoaded = false
                } else {
                  this.pageIsLoaded = true
                  document.getElementById('error-regex').innerHTML = response.error;
                }
              }
          )
        }
      }

      var timestampLimitTest = JSON.parse(localStorage.getItem('limitTest'));
      // Alert avant la fin des tests
      this.setAlertFinishAllTests(timestampLimitTest);
    },
    previous: function () {
      this.error = false;
      if (!this.pageIsLoaded) return
      if (this.type === 'video') {
        // Pour le type vidéo, pas de navigation next/previous
        return
      } else if (this.type === 'multiple_checkbox_with_text' && !this.$refs.markdowndetails.ifFirstPage) {
        if (this.previousStatement === this.statement) {
          this.pageIsLoaded = false
          this.saveResponse().then(
              (response) => {
                if (undefined === response.error) {
                  this.indexQuestion = this.indexQuestion - 1
                  this.changeQuestion();
                } else {
                  this.pageIsLoaded = true
                  document.getElementById('error-regex').innerHTML = response.error;
                }
              }
          )

        }
        this.$refs.markdowndetails.ifFirstPage = true;
        this.ifFirstPage = true;
      } else if (this.type === 'argumentaire') {
        if (this.previousStatement === this.statement) {
          this.pageIsLoaded = false
          this.saveResponse().then(
              (response) => {
                if (undefined === response.error) {
                  this.indexQuestion = this.indexQuestion - 1
                  this.changeQuestion()
                } else {
                  this.pageIsLoaded = true
                  document.getElementById('error-regex').innerHTML = response.error;
                }
              }
          )

        }
        this.$refs.markdowndetails.ifFirstPage = true;
        this.ifFirstPage = true;
      } else {
        this.pageIsLoaded = false
        this.saveResponse().then(
            (response) => {
              if (undefined === response.error) {
                this.indexQuestion = this.indexQuestion - 1
                this.changeQuestion()
              } else {
                this.pageIsLoaded = true
                document.getElementById('error-regex').innerHTML = response.error;
              }
            }
        )
      }

      var timestampLimitTest = JSON.parse(localStorage.getItem('limitTest'));
      // Alert avant la fin des tests
      this.setAlertFinishAllTests(timestampLimitTest);
    },
    setAlertFinishAllTests(timestamp) {
      const oneMinute = 60;
      const fiveMinutes = 5 * 60;
      const currentTime = Math.floor(new Date().getTime() / 1000);

      let timeDifference = timestamp - currentTime;
      if (timeDifference < 0) {
        this.isModalRappelVisible = true
        this.messageRappel = "Il ne reste plus de temps, clotûre des tests !"
        this.$router.push({name: 'mes-tests'});
      }

      var rappelLimitTest = JSON.parse(localStorage.getItem('rappelLimitTest'));
      if (timeDifference > oneMinute) {
        timeDifference -= fiveMinutes
        if (timeDifference < 0 && rappelLimitTest === 0) {
          localStorage.setItem('rappelLimitTest', 1)
          setTimeout(() => {
            this.messageRappel = "Attention ! Il vous reste moins de 5 minutes avant la clotûre des tests !"
            this.isModalRappelVisible = true
          }, timeDifference);
        }
      } else {
        timeDifference -= oneMinute
        if (timeDifference < 0 && rappelLimitTest === 1) {
          localStorage.setItem('rappelLimitTest', 2)
          setTimeout(() => {
            this.messageRappel = "Attention ! Il ne reste plus que 1 minute avant la clotûre des tests ! Pensez à sauvegarder votre travail."
            this.isModalRappelVisible = true
          }, timeDifference);
        }
      }
    },
    displayLimitTest() {
      var timestampLimitTest = JSON.parse(localStorage.getItem('limitTest'));
      var totalMinutes = JSON.parse(localStorage.getItem('totalMinutesRaisonnement'));

      switch (this.domain) {
        case 'expression':
          totalMinutes = JSON.parse(localStorage.getItem('totalMinutesExpression'));
          break
        case 'raisonnement':
          totalMinutes = JSON.parse(localStorage.getItem('totalMinutesRaisonnement'));
          break
        case 'calcul':
          totalMinutes = JSON.parse(localStorage.getItem('totalMinutesCalculs'));
          break
        case 'argumentation':
          totalMinutes = JSON.parse(localStorage.getItem('totalMinutesArgumentation'));
          break
      }

      const currentTimestamp = Math.floor(new Date().getTime() / 1000);

      if ((timestampLimitTest - currentTimestamp) <= 0) {
        alert('Temps écoulé')
        setTimeout(this.$router.push({name: 'dashboard'}), 2000);
      }

    },
    changeQuestion: function () {
      this.type = 'à définir'

      var index = this.indexQuestion - 1
      TestApi.getQuestion(this.arrayQuestions[index].idQuestion).then(
          (response) => {
            this.idQuestion = response.data.id
            this.type = response.data.type
            this.question = response.data.question
            this.statement = response.data.statement
            this.audio = response.data.audio
            this.propositions = response.data.proposedAnswers
            this.title = response.data.title
            this.image = response.data.image
            this.regex = response.data.regex
            if (false === this.ifProduction && response.data.answer) {
              document.getElementById('answer_dev').innerText = response.data.answer
            }

          }
      );
    },
    saveListen: function () {
      UserService.saveListen(this.idUserTest, this.listen);
    },
    saveResponse: function () {
      var answer = this.$refs.markdowndetails.answer // todo do not use $refs gros risque de modifier dans l'objet sans se rendre compte de l'impact

      if (answer != null && !Array.isArray(answer)) {
        answer = answer.replace(/<br>/g, "<br />")
      }
      return UserService.saveAnswerQuestion(this.idUserTest, this.indexQuestion, answer).then(
          (response) => {
            return response
          }
      );
    },
    intervalAction: function () {
      let now = new Date();
      let counter = Math.round((this.dateEnd - now) / 1000);

      if (counter < 300 && null !== document.getElementById("countDown")) {
        document.getElementById("countDown").classList.add('questionnaire-question-bar-info-left-critical')
      }

      if (counter <= 0) {
        clearInterval(this.intCountDow)
        alert('Temps écoulé')
        this.$router.push({name: 'mes-tests'})
      } else {
        this.updateTimer();
      }
    },
    updateTimer: function () {
      if (null === document.getElementById("countDown")) {
        clearInterval(this.intCountDow);
        return;
      }

      let now = new Date();
      let seconds = Math.round((this.dateEnd - now) / 1000);

      let minutes = Math.floor(seconds / 60)
      let heures = Math.floor(minutes / 60)

      heures %= 24
      minutes %= 60
      seconds %= 60


      minutes = (new Array(3).join('0') + minutes).slice(-2)
      seconds = (new Array(3).join('0') + seconds).slice(-2)


      document.getElementById("countDown").innerHTML = heures + ':' + minutes + ':' + seconds


      if (this.arrangementThirdTime) {
        document.getElementById("initialTimer").innerHTML = `Avec tiers temps`
      }
    },

    startCountDown: function () {
      this.intCountDow = setInterval(this.intervalAction, 1000);
    },
    close: function () {
      this.$emit('close');
    },
    finish: function () {
      UserService.saveQuestionnaireToEva().then(
          () => {
            UserService.terminatedTest(this.idUserTest).then(
                setTimeout(function (router) {
                  router.push({name: RouteEnum.CANDIDACY_TESTS})
                }, 1000, this.$router)
            );
          },
          (error) => {
            this.loading = false;
            alert(error.response.data.detail)
          }
      )
    },
    showModal: function () {
      this.isModalVisible = true;
    },
    closeModal: function () {
      this.isModalVisible = false;
    },
    showModalFinish: function () {
      this.isModalFinishVisible = true;
    },
    closeModalFinish: function () {
      this.isModalFinishVisible = false;
    },
    showModalRappel: function () {
      this.isModalRappelVisible = true;
    },
    closeModalRappel: function () {
      this.isModalRappelVisible = false;
    },
    blockPrintScreen(event) {
      if (event.keyCode === 44) {
        event.preventDefault();
      }
    },
    onVideoCompleted() {
      setTimeout(() => {
        this.autoSubmit = true;
        this.type = "finish"
      }, 2000)
    }
  },
  mounted() {
    switch (this.domain) {
      case 'introduction':
        this.domainId = 18;
        this.header = 'Vidéo d\'introduction'
        this.type = 'video'
        this.maxQuestion = 1
        this.indexQuestion = 1
        break;
      case 'expression':
        this.domainId = 1;
        this.header = 'Expression'
        break
      case 'raisonnement':
        this.domainId = 2;
        this.header = 'Raisonnement'
        break
      case 'calcul':
        this.domainId = 3;
        this.domainId = 3;
        this.header = 'Calculs professionnels '
        break
      case 'argumentation':
        this.domainId = 4;
        this.domainId = 4;
        this.header = 'Argumentation'
        break
    }
    UserService.getUserTestQuestions(this.domainId).then(
        (response) => {
          if (false === response.data.ifTest) {
            this.$router.push({name: RouteEnum.CANDIDACY_TESTS})
          }
          this.idUserTest = response.data.id
          //
          // if(this.domain === 'introduction') {
          //   return;
          // }

          this.type = response.data.type
          this.arrayQuestions = response.data.questions
          this.maxQuestion = response.data.numberQuestions
          this.arrayResponses = response.data.responses
          this.endedAt = response.data.endedAt?.date || null
          this.listen = response.data.listenTime
          this.duration = response.data.duration
          this.arrangementThirdTime = response.data.arrangementThirdTime

          let remainingTime = response.data.remainingTime;
          this.dateEnd = new Date((new Date()).getTime() + (remainingTime * 1000));

          this.startCountDown()

          // Skip question loading for video-only tests (like introduction)
          if (this.arrayQuestions && this.arrayQuestions.length > 0) {
            TestApi.getQuestion(this.arrayQuestions[0].idQuestion).then(
                (response) => {
                  this.idQuestion = response.data.id
                  this.type = response.data.type
                  this.question = response.data.question
                  this.statement = response.data.statement
                  this.audio = response.data.audio
                  this.propositions = response.data.proposedAnswers
                  this.title = response.data.title
                  this.image = response.data.image
                  this.regex = response.data.regex
                  if (false === this.ifProduction && response.data.answer) {
                    document.getElementById('answer_dev').innerText = response.data.answer
                  }
                }
            );
          }

        }
    );
    this.intervalFinishTests = setInterval(this.displayLimitTest, 1000)
  }
};
</script>
<style scoped>
.questionnaire-question-header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.questionnaire-question-header-title {
  text-align: center;
}
</style>
